import { render, staticRenderFns } from "./NewDiagnoseModal.vue?vue&type=template&id=88a54150&scoped=true"
import script from "./NewDiagnoseModal.vue?vue&type=script&lang=js"
export * from "./NewDiagnoseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a54150",
  null
  
)

export default component.exports